export default __webpack_public_path__ + "static/media/squat.5f2d13e9.svg";